import api from '@/api';

export default {
  sendMessage: (orderId, message) => api.post('chat/send-message', { orderId, message }),
  openRoom: orderId => api.post('chat/open-room', { orderId }),
};
